export default "__VITE_ASSET__QMEZAxtJ__"